import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const articles = [
  { id:1, cat:'Design Tips', title:'10 Ways to Make Your Small Living Room Look Bigger', date:'May 10, 2025', read:'6 min', featured:true, bg:'hsl(20,8%,88%)' },
  { id:2, cat:'Trends', title:'Top Interior Design Trends Dominating 2025', date:'May 2, 2025', read:'8 min', featured:true, bg:'hsl(200,6%,86%)' },
  { id:3, cat:'Kitchen', title:'Modular vs Custom Kitchen: Which Is Right for You?', date:'Apr 28, 2025', read:'5 min', featured:false, bg:'hsl(120,6%,87%)' },
  { id:4, cat:'Bedroom', title:'Master Bedroom Design Ideas for a Peaceful Retreat', date:'Apr 20, 2025', read:'7 min', featured:false, bg:'hsl(30,8%,86%)' },
  { id:5, cat:'Budget', title:'How to Plan Your Interior Budget: A Complete Guide', date:'Apr 15, 2025', read:'10 min', featured:false, bg:'hsl(60,7%,87%)' },
  { id:6, cat:'Materials', title:'Plywood vs MDF: What Should You Choose for Furniture?', date:'Apr 8, 2025', read:'5 min', featured:false, bg:'hsl(180,5%,88%)' },
  { id:7, cat:'Color', title:'The Perfect Color Palettes for Indian Homes in 2025', date:'Mar 30, 2025', read:'6 min', featured:false, bg:'hsl(340,6%,87%)' },
  { id:8, cat:'Vastu', title:'Vastu-Compliant Interior Design: A Modern Approach', date:'Mar 22, 2025', read:'8 min', featured:false, bg:'hsl(40,9%,85%)' },
  { id:9, cat:'Storage', title:'Clever Storage Solutions for Compact Apartments', date:'Mar 15, 2025', read:'6 min', featured:false, bg:'hsl(80,6%,87%)' },
];

const categories = ['All', 'Design Tips', 'Trends', 'Kitchen', 'Bedroom', 'Budget', 'Materials', 'Color', 'Vastu', 'Storage'];

export default function Magazine() {
  const navigate = useNavigate();
  const [activeCat, setActiveCat] = useState('All');
  const [search, setSearch] = useState('');

  const filtered = articles.filter(a => {
    if (activeCat !== 'All' && a.cat !== activeCat) return false;
    if (search && !a.title.toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });

  const featured = filtered.filter(a => a.featured);
  const rest = filtered.filter(a => !a.featured);

  return (
    <div style={{ paddingTop:68 }}>
      {/* Hero */}
      <div style={{ background:'#343F86', padding:'72px 40px', position:'relative', overflow:'hidden' }}>
        <div style={{ position:'absolute', top:'-30%', right:'-5%', width:400, height:400, borderRadius:'50%', background:'radial-gradient(circle, rgba(196,168,130,0.06) 0%, transparent 70%)' }} />
        <div className="container">
          <div style={{ fontSize:11, fontWeight:700, letterSpacing:3, textTransform:'uppercase', color:'var(--gold)', marginBottom:14 }}>Magazine</div>
          <h1 style={{ fontFamily: "'Montserrat', 'Inter', sans-serif", fontSize:'clamp(36px,5vw,60px)', color:'#fff', fontWeight:400, marginBottom:16 }}>
            Design<br/>Inspiration & Ideas
          </h1>
          <p style={{ fontSize:15, color:'#8A8F9C', maxWidth:480, lineHeight:1.7 }}>
            Expert tips, design trends, and real home transformations to inspire your next interior project.
          </p>
          {/* Search */}
          <div style={{ display:'flex', marginTop:32, maxWidth:440 }}>
            <input
              className="newsletter-input"
              placeholder="Search articles..."
              value={search}
              onChange={e => setSearch(e.target.value)}
              style={{ background:'rgba(255,255,255,0.07)', borderColor:'rgba(255,255,255,0.12)', color:'#fff', padding:'13px 20px' }}
            />
            <button className="newsletter-btn" style={{ background:'var(--gold)' }}>Search</button>
          </div>
        </div>
      </div>

      {/* Category filter */}
      <div style={{ background:'#fff', borderBottom:'1px solid #E1E3EE', padding:'0', position:'sticky', top:68, zIndex:100, overflowX:'auto' }}>
        <div className="container">
          <div style={{ display:'flex', gap:0 }}>
            {categories.map(c => (
              <button key={c}
                className={`tab-btn ${activeCat===c ? 'active':''}`}
                onClick={() => setActiveCat(c)}
                style={{ whiteSpace:'nowrap' }}
              >{c}</button>
            ))}
          </div>
        </div>
      </div>

      <section className="section">
        <div className="container">
          {/* Featured */}
          {featured.length > 0 && (
            <div style={{ marginBottom:56 }}>
              <div className="section-label" style={{ marginBottom:24 }}>Featured</div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:24 }}>
                {featured.map((a, i) => (
                  <div key={a.id} className="mag-card" style={{ cursor:'pointer' }} onClick={() => {}}>
                    <div style={{ height:i===0?280:200, background:a.bg, display:'flex', alignItems:'center', justifyContent:'center', overflow:'hidden', transition:'transform 0.4s ease' }}
                      onMouseEnter={e => e.currentTarget.style.transform='scale(1.02)'}
                      onMouseLeave={e => e.currentTarget.style.transform=''}
                    >
                      <span style={{ fontSize:12, color:'#8A8F9C', letterSpacing:1 }}>{a.cat}</span>
                    </div>
                    <div className="mag-card-body">
                      <div className="mag-card-cat">{a.cat}</div>
                      <div className="mag-card-title">{a.title}</div>
                      <div style={{ display:'flex', gap:16 }}>
                        <div className="mag-card-date">{a.date}</div>
                        <div className="mag-card-date">{a.read} read</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Rest */}
          {rest.length > 0 && (
            <div>
              <div className="section-label" style={{ marginBottom:24 }}>
                {activeCat === 'All' ? 'Latest Articles' : activeCat}
              </div>
              <div className="card-grid card-grid-3">
                {rest.map(a => (
                  <div key={a.id} className="mag-card" onClick={() => {}}>
                    <div style={{
                      height:180, background:a.bg, overflow:'hidden',
                      display:'flex', alignItems:'center', justifyContent:'center',
                      transition:'transform 0.4s ease',
                    }}
                      onMouseEnter={e => e.currentTarget.style.transform='scale(1.04)'}
                      onMouseLeave={e => e.currentTarget.style.transform=''}
                    >
                      <span style={{ fontSize:12, color:'#8A8F9C', letterSpacing:1 }}>{a.cat}</span>
                    </div>
                    <div className="mag-card-body">
                      <div className="mag-card-cat">{a.cat}</div>
                      <div className="mag-card-title">{a.title}</div>
                      <div style={{ display:'flex', gap:16 }}>
                        <div className="mag-card-date">{a.date}</div>
                        <div className="mag-card-date">{a.read} read</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {filtered.length === 0 && (
            <div style={{ textAlign:'center', padding:'80px 0' }}>
              <div style={{ fontSize:48, marginBottom:16 }}>📖</div>
              <div style={{ fontSize:20, fontWeight:600, color:'#343F86', marginBottom:8 }}>No articles found</div>
              <button className="btn-outline" onClick={() => { setActiveCat('All'); setSearch(''); }}>Reset Filters</button>
            </div>
          )}
        </div>
      </section>

      {/* Newsletter */}
      <section style={{ background:'#ECEEF6', padding:'64px 0' }}>
        <div className="container" style={{ textAlign:'center' }}>
          <div className="section-label">Newsletter</div>
          <h2 className="section-title" style={{ marginBottom:12 }}>Stay Inspired</h2>
          <p style={{ fontSize:14, color:'#5B6072', marginBottom:28 }}>Get the latest design trends and tips delivered to your inbox weekly.</p>
          <div style={{ display:'flex', justifyContent:'center' }}>
            <div className="newsletter-form">
              <input className="newsletter-input" placeholder="Enter your email address" type="email" />
              <button className="newsletter-btn">Subscribe</button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
